import React from "react";
import ChatBotTextShimmer from "./ChatBotTextShimmer";
import ChatBotSkeletonLoader from "./ChatBotSkeletonLoader";

interface ChatBotLoadingSkeletonUIProps {
  currentQuestion: string;
  inputValue: string;
  skeletonWidths: string[];
  handleSearch: () => void;
}

const ChatBotLoadingSkeletonUI: React.FC<ChatBotLoadingSkeletonUIProps> = ({
  currentQuestion,
  inputValue,
  skeletonWidths,
  handleSearch,
}) => {
  return (
    <>
      <div className="text-[#9C9EA3] bg-white/10 px-4 text-[14px] py-3 min-h-[48px] w-full rounded-[20px] outline-none whitespace-nowrap overflow-hidden flex justify-between items-center ">
        <div className="flex-grow overflow-hidden text-ellipsis whitespace-nowrap">{currentQuestion}</div>
        <div
          className={`cursor-pointer w-[24px] h-[24px] flex items-center justify-center ml-[6px]`}
          onClick={inputValue.trim() ? handleSearch : undefined}
        >
          <div
            className="w-4 h-4 bg-white dark:bg-white rounded-sm animate-spin transition duration-700"
            style={{ animationDuration: "3s" }}
          />
        </div>
      </div>

      <div className="text-center mt-[5px]">
        <ChatBotTextShimmer />
      </div>

      <div className="mt-14">
        <ChatBotSkeletonLoader widths={skeletonWidths} />
      </div>
    </>
  );
};

export default ChatBotLoadingSkeletonUI;
